import React, { useEffect } from 'react';
import {
  CertificationsSelect,
  ClinicalSpecialtiesSelect,
  TechnologiesSelect,
} from '@clinician-profile/components';
import {
  formatSelectedSpecialties,
  formatSelectedCertifications,
} from '@clinician-profile/services';
import { YearsOfExperienceSelect } from '@jobs/components';
import {
  StaffingRequestType,
  ClinicalSpecialtyType,
  CertificationType,
  CertificationCustomType,
  ClinicalSpecialtyCustomType,
  TechnologyType,
} from '@jobs/graphql/queries/staffing-request-query';
import { Gutter, Title } from '@common/components';

type EditStaffingRequestFormPartTwoProps = {
  staffingRequest: StaffingRequestType;
  clinicalSpecialties: ClinicalSpecialtyType[];
  technologies: TechnologyType[];
  certifications: CertificationType[];
  visible: boolean;
  selectedSpecialties: ClinicalSpecialtyCustomType[];
  setSelectedSpecialties: (specialties: ClinicalSpecialtyCustomType[]) => void;
  selectedCertifications: CertificationCustomType[];
  setSelectedCertifications: (
    certifications: CertificationCustomType[]
  ) => void;
};

export function EditStaffingRequestFormPartTwo({
  staffingRequest,
  clinicalSpecialties,
  technologies,
  certifications,
  visible,
  selectedSpecialties,
  setSelectedSpecialties,
  selectedCertifications,
  setSelectedCertifications,
}: EditStaffingRequestFormPartTwoProps) {
  useEffect(() => {
    const formattedSpecialties = formatSelectedSpecialties(
      staffingRequest.staffingRequestSpecialties || []
    );
    const formattedCertifications = formatSelectedCertifications(
      staffingRequest.staffingRequestCertifications || []
    );

    setSelectedSpecialties(formattedSpecialties);
    setSelectedCertifications(formattedCertifications);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffingRequest]);

  return (
    <>
      {visible && (
        <Gutter direction="bottom" size="md">
          <Title size="h3">Experience</Title>
        </Gutter>
      )}
      <ClinicalSpecialtiesSelect
        clinicalSpecialties={clinicalSpecialties}
        selectedSpecialties={selectedSpecialties}
        setSelectedSpecialties={setSelectedSpecialties}
        hidden={!visible}
      />
      <YearsOfExperienceSelect hidden={!visible} />
      <TechnologiesSelect technologies={technologies} hidden={!visible} />

      {visible && (
        <Gutter direction="bottom" size="md">
          <Title size="h3">Certifications</Title>
        </Gutter>
      )}
      <CertificationsSelect
        certifications={certifications}
        selectedCertifications={selectedCertifications}
        setSelectedCertifications={setSelectedCertifications}
        hidden={!visible}
      />
    </>
  );
}
